import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../assets/ResetSettings.svg';

export const ResetSettings = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
